import React from 'react'
import { bonusPointsStyles as styles } from "./buyPoint.tailwind.js";
import { connect, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { calculateTax, MAX_VALUE, pointsValidationSchema, PRICE_PER_POINT, TAX } from './buyPoint.data.js';
import InputController from '../../../Input/InputField/InputController.jsx';
import Button from '../../../Button/Button.jsx';
import { useForm } from 'react-hook-form';
import { buyPoints } from '../../../../../redux/slices/rewardSlice.js';
import purchase_points from '../../../../../assets/svgs/purchase_points.svg';

const BuyPointCheckoutInfo = ({ purchasePoints, onClose }) => {
  const { isPurchasingPoints } = useSelector(state => state.reward);

  const { control, handleSubmit, watch, formState: { errors, isDirty, isLoading } } = useForm({
    resolver: yupResolver(pointsValidationSchema),
    defaultValues: {
      points: "",
    }
  });

  const points = watch("points");
  const subTotal = (PRICE_PER_POINT || 1) * points
  const tax = calculateTax(subTotal);

  const handleInput = (event) => {
    const inputValue = event.target.value;
    // Ensure input is a positive number and within the max limit
    if (Number(inputValue) < 0) {
      event.target.value = ""; // Reset the input if it's negative
    } else if (Number(inputValue) > MAX_VALUE) {
      event.target.value = MAX_VALUE; // Restrict input to MAX_VALUE
    }
  };

  const handlePurchase = async(_data) => {
    const data = {
      points: _data.points
    }
    
    await purchasePoints(data);
  };

  return (
    <>
      <div className='flex flex-row gap-[10px] items-end'>
        <img src={purchase_points} alt='points' className={styles.points_img}></img>
        <span className={styles.heading}>Purchase Points</span>
      </div>
      {/* Form */}
      <form onSubmit={handleSubmit(handlePurchase)} className={styles.formContainer}>
        {/* Points Input */}
        <div className="flex flex-col gap-[8px]">
            <InputController
                autoFocus={true}
                showLabel={true}
                label="Enter the number of points"
                type="number"
                name="points"
                control={control}
                error={!!errors.points}  // Check if there's an error with 'points' field
                helperText={errors.points?.message} // Show error message if any
                onInput={handleInput}
                min={100}
            />
            <span className={styles.noteText}>Note: Enter number in multiples of 100</span>
        </div>

        {/* Payment Details(Subtotal, Taxes, Total) */}
        {points && (
            <div>
            <div className="flex justify-between pb-[5px]">
                <span className="text-themeColor">Subtotal:</span>
                <span>{points ? `$ ${subTotal}` : "--"}</span>
            </div>
            <div className="flex justify-between pb-[5px]">
                <span className="text-themeColor">Taxes
                    <span className='text-primaryHeading font-[400]'> ({TAX || 5}%)</span>
                    {" "}:
                </span>
                <span>{points ? `$ ${tax}` : `--`}</span>
            </div>
            <div className="flex justify-between border-t border-primary pb-[5px]">
                <span className="text-themeColor">Total:</span>
                <span>{points ? `$ ${parseFloat(subTotal) + parseFloat(tax)}` : "--"}</span>
            </div>
            </div>
        )}

        {/* Continue/ Cancel Button */}
        <div className={styles.buttonContainer}>
            <Button variant="primary" type="submit" className={styles.button} disabled={isLoading || !isDirty || isPurchasingPoints}>
                {isPurchasingPoints ? `Proceeding...` : `Continue To Purchase`}
            </Button>
            <Button variant="lighttheme" type="button" onClick={onClose} className={`${styles.button}`}>Cancel</Button>
        </div>
      </form>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
    purchasePoints: (data) => dispatch(buyPoints(data)),
});

export default connect(null, mapDispatchToProps)(BuyPointCheckoutInfo);
